import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './CarouselPage.css';

const CarouselPage = ({ images, styles }) => {
    return (
        <div className="carousel-container">
        <Carousel fade>
          {images.map((img, index) => (
            <Carousel.Item key={index}>
              <img className="carousel-image" style={img.style} src={img.src} alt={img.alt} />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    );
  };

export default CarouselPage